var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{attrs:{"id":"qqLoginBtn"},on:{"click":_vm.doQQLogin}})])}
var staticRenderFns = []

export { render, staticRenderFns }